/* eslint-disable @typescript-eslint/no-empty-function */
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { OverviewMovableComponents } from '../utils/constants/constants';
export interface awardDetailsType {
  count: number;
  expirationDate: string;
}

export interface FreeNightDetails {
  awardType?: {
    code?: string;
    label?: string;
    description?: string;
    enumCode?: string;
  };
  expirationDate?: string;
  isCancellable?: boolean;
  issueDate?: string;
  numberOfNights?: number;
  points?: number;
  status?: 'available' | 'applied' | 'approved' | 'requestPending';
  property?: {
    id?: string;
    name?: string;
    imageUrl?: string;
  };
}

export interface FreeNightAwardsInfo {
  total?: number;
  edges?: {
    node?: FreeNightDetails;
  }[];
}
export interface OverviewState {
  awardsCount: number;
  suiteNightAwardInfo?: Array<awardDetailsType>;
  cardModalId: string;
  freeNightAwardInfo: FreeNightAwardsInfo;
  setFreeNightAwardInfo: (value: FreeNightAwardsInfo) => void;
  setCardModalId: (value: string) => void;
  setAwardsCount: (count: number, details: Array<awardDetailsType>) => void;
}

const initialState: OverviewState = {
  awardsCount: 0,
  cardModalId: '',
  freeNightAwardInfo: {},
  setFreeNightAwardInfo: () => {},
  setCardModalId: () => {},
  setAwardsCount: () => {},
};

const overviewStore: StateCreator<OverviewState> = set => {
  return {
    ...initialState,
    setAwardsCount: (count: number, details?: Array<awardDetailsType>) => {
      set({ awardsCount: count, suiteNightAwardInfo: details });
    },
    setCardModalId: (value: string) => {
      set({ cardModalId: value });
    },
    setFreeNightAwardInfo: (value: FreeNightAwardsInfo) => {
      set({ freeNightAwardInfo: value });
    },
  };
};

export const useOverviewStore = createAppStore(overviewStore, {
  usePersistentStore: false,
});

/**
 * Account refresh store
 * start from here
 */

export type MessageEntryType = {
  [key: string]: {
    isBirthdayMessageRemove?: string;
    isEarningMessageRemove?: {
      propertyId?: string;
      stayDate?: string;
    };
    isLifetimeMessageRemove?: string;
    isRenewMessageRemove?: string;
    isNewAchieverMessageRemove?: string;
    isPointsExpiringMessageRemove?: string;
    storedPointsExpireDate?: string;
    altCustId?: string;
    storedMemberLevel?: string;
    storedMemberLiftimeCode?: string;
    savedAt?: string;
    loggedInAt?: string;
    isFnaAwardMessageRemove?: {
      issueDate?: string;
      expiryDate?: string;
    };
  };
};

export type AccountPersistentRefreshState = {
  /**
   * defaine types here
   */
  storedInfoForInlineMessage?: MessageEntryType;
  storedInfoForInlineModalMessage?: MessageEntryType;
  updateValuesInAccountRefreshStore: (val?: Partial<AccountPersistentRefreshState>) => void;
};

const AccountPersistentRefreshInitialState: AccountPersistentRefreshState = {
  updateValuesInAccountRefreshStore: () => {},
};

const AccountPersistentRefreshStore: StateCreator<AccountPersistentRefreshState> = set => {
  /**
   * use this store if we have to save any information on local storage
   */

  return {
    ...AccountPersistentRefreshInitialState,
    updateValuesInAccountRefreshStore: (value?: Partial<AccountPersistentRefreshState>) => {
      /**
       * in any case we need to update single object
       */
      set(prevState => ({ ...prevState, ...value }));
    },
  };
};
export const useAccountRefreshPersistantStore = createAppStore(AccountPersistentRefreshStore, {
  usePersistentStore: true,
  useLocalStorage: true,
  persistentStoreName: 'AccountRefreshPageLocalStore',
});

/**
 * account refresh non persistent store start from here
 *
 *
 *
 *
 *
 * space for future use
 */

export type EarningSummaryType = {
  // Property Information
  propertyName: string;
  propertyId: string;
  brandId?: string;
  propertyImageUrl?: string;

  // Stay Dates
  stayStartDate: string; // ISO date string
  stayEndDate: string; // ISO date string
  postDate: string; // When earnings were posted (ISO date string)
  numberOfNights: number;

  // Earnings Breakdown
  totalEliteNightCredits: number; // ENCs earned
  totalPoints: number; // Total points earned
  basePoints: number; // Base points from stay
  elitePoints: number; // Elite bonus points
  bonusPoints: number; // Extra promotional points
  currencyCode?: string;
  // Activity Metadata
  isQualifyingActivity: boolean;
  activityType: string; // e.g., "STAY", "QUALIFYING"
  activityDescription?: string;
} | null;
type IsComponentLoading = {
  [OverviewMovableComponents.UPCOMING_TRIPS]: boolean;
  [OverviewMovableComponents.EARNINGS_SUMMARY]: boolean;
};
type AccountNonPersistentRefreshState = {
  isEarningSummaryModalOpen: boolean;
  isMemberBenefitsModalOpen: boolean;
  isUpcomingTripWithin30days?: boolean;
  isComponentLoading: IsComponentLoading;
  earningSummary?: EarningSummaryType;
  earningSummaryPropertyImageUrl?: string | null;
  updateValuesInNonPersistentStore: (value: Partial<AccountNonPersistentRefreshState>) => void;
  setAccountRefreshComponentLoading: (value: Partial<IsComponentLoading>) => void;
};

const AccountNonPersistentRefreshInitialState: AccountNonPersistentRefreshState = {
  isEarningSummaryModalOpen: false,
  isMemberBenefitsModalOpen: false,
  earningSummary: undefined,
  isUpcomingTripWithin30days: false,
  isComponentLoading: {
    [OverviewMovableComponents.UPCOMING_TRIPS]: true,
    [OverviewMovableComponents.EARNINGS_SUMMARY]: true,
  },
  updateValuesInNonPersistentStore: () => {},
  setAccountRefreshComponentLoading: () => {},
};
const AccountNonPersistentRefreshStore: StateCreator<AccountNonPersistentRefreshState> = set => {
  /**
   * use this store if we don't have to save any information on local storage
   */
  return {
    ...AccountNonPersistentRefreshInitialState,

    updateValuesInNonPersistentStore: (value?: Partial<AccountNonPersistentRefreshState>) => {
      set(prevState => ({ ...prevState, ...value }));
    },
    setAccountRefreshComponentLoading: (value: Partial<IsComponentLoading>) => {
      set(prevState => ({
        ...prevState,
        isComponentLoading: { ...prevState.isComponentLoading, ...value },
      }));
    },
  };
};
export const useAccountRefreshNonPersistentStore = createAppStore(AccountNonPersistentRefreshStore, {
  usePersistentStore: false,
});
